import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css, useTheme} from "@emotion/react";

import {Col, Row} from "@pg-design/grid-module";
import {display, flexAbsoluteCenter, flexAlignCenter, mb, mh, ml, mr, onDesktop, order, pl, pointer, textAlign} from "@pg-design/helpers-css";
import {CheckIcon, EmailIcon, FacebookIcon, LinkedinIcon, TwitterIcon, WebsiteIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {parseSearch} from "@pg-mono/request";

import {IRPStore} from "../../../app/rp_reducer";
import {AuthorBoxImgPlaceholder} from "../../components/authors/AuthorBoxImgPlaceholder";

export const AuthorDescription = (props: {className?: string}) => {
    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author?.name);
    const authorImageUrl = useSelector((state: IRPStore) => state.article.authorDetail.author?.image?.a_img_360x360);
    const authorDescription = useSelector((state: IRPStore) => state.article.authorDetail.author?.description);
    const location = useLocation();
    const articlesPage = parseSearch(location.search)?.page;

    return (
        <Row as="section" css={props.className}>
            <Col sm={4} md={5} lg={5} css={flexAbsoluteCenter}>
                {!!authorImageUrl ? (
                    <Image ratio={{xs: "1/1"}} css={authorImage} src={authorImageUrl} alt={authorName ?? ""} width="360px" height="360px" />
                ) : (
                    <AuthorBoxImgPlaceholder />
                )}
            </Col>
            <Col sm={4} md={7} lg={11}>
                <div css={authorInfoOrder}>
                    <Text css={[mb(2), order(1)]} variant="headline_1">
                        {authorName} {articlesPage && ` - strona ${articlesPage}`}
                    </Text>
                    <AuthorSocialIcons css={[order(4), pl(1), mb(4), onDesktop(order(2), mb(0))]} />
                    <AuthorCategories css={[order(3), authorColHolder]} />
                </div>

                <Text variant="body_copy_2" css={[mb(3), display("block"), textAlign("center"), onDesktop(mb(0), textAlign("left"))]}>
                    <span dangerouslySetInnerHTML={{__html: authorDescription?.replace(/\n/g, "<br />") ?? ""}} />
                </Text>
            </Col>
        </Row>
    );
};

const AuthorCategories = (props: {className?: string}) => {
    const authorCategories = useSelector((state: IRPStore) => state.article.authorDetail.author?.stats?.categories);
    const theme = useTheme();
    const brandColor = theme.colors.primary;
    const lightColor = theme.colors.gray[700];

    return (
        <>
            {!!authorCategories && (
                <div css={props.className}>
                    {authorCategories.map((category) => (
                        <div key={category} css={categoryItem}>
                            <CheckIcon fill={lightColor} size="1.6" wrapperSize="1.6" wrapperColor={brandColor} />
                            <Text css={ml(1)} color={lightColor} variant="body_copy_2">
                                {category}
                            </Text>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

const AuthorSocialIcons = (props: {className?: string}) => {
    const facebook = useSelector((state: IRPStore) => state.article.authorDetail.author?.facebook);
    const twitter = useSelector((state: IRPStore) => state.article.authorDetail.author?.twitter);
    const email = useSelector((state: IRPStore) => state.article.authorDetail.author?.email);
    const linkedin = useSelector((state: IRPStore) => state.article.authorDetail.author?.linkedin);
    const website = useSelector((state: IRPStore) => state.article.authorDetail.author?.website);

    const social = [
        ...(facebook ? [{alt: "facebook", url: facebook, icon: FacebookIcon}] : []),
        ...(twitter ? [{alt: "twitter", url: twitter, icon: TwitterIcon}] : []),
        ...(linkedin ? [{alt: "linkedin", url: linkedin, icon: LinkedinIcon}] : []),
        ...(website ? [{alt: "website", url: website, icon: WebsiteIcon}] : []),
        ...(email ? [{alt: "email", url: `mailto:${email}`, icon: EmailIcon, target: "_blank"}] : [])
    ];

    return (
        <>
            <div css={props.className}>
                {social.map(({icon: Icon, alt, url, target}) => {
                    return (
                        <a key={alt} href={url as string} rel="nofollow noopener" css={[pointer, mr(3), display("inline-block")]} target={target}>
                            <Icon size="2.5" key={alt} />
                        </a>
                    );
                })}
            </div>
        </>
    );
};

const authorImage = [
    mh("auto"),
    mb(4),
    display("block"),
    css`
        border-radius: 50%;
        width: 27.2rem;
        height: 27.2rem;
    `,
    onDesktop(css`
        width: 36rem;
        height: 36rem;
        ${mh(0)}
        ${mb(0)}
    `)
];

const authorInfoOrder = css`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${onDesktop(css`
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
    `)};
`;

const authorColHolder = css`
    ${flexAlignCenter};
    ${mb(3)};
    flex-wrap: wrap;
    justify-content: center;
    ${onDesktop(css`
        justify-content: flex-start;
    `)}
`;

const categoryItem = css`
    ${flexAlignCenter};
    ${mr(2)};
    white-space: nowrap;
`;
import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css, useTheme} from "@emotion/react";

import {Col, Row} from "@pg-design/grid-module";
import {display, flexAbsoluteCenter, flexAlignCenter, mb, mh, ml, mr, onDesktop, order, pl, pointer, textAlign} from "@pg-design/helpers-css";
import {CheckIcon, EmailIcon, FacebookIcon, LinkedinIcon, TwitterIcon, WebsiteIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {parseSearch} from "@pg-mono/request";

import {IRPStore} from "../../../app/rp_reducer";
import {AuthorBoxImgPlaceholder} from "../../components/authors/AuthorBoxImgPlaceholder";

export const AuthorDescription = (props: {className?: string}) => {
    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author?.name);
    const authorImageUrl = useSelector((state: IRPStore) => state.article.authorDetail.author?.image?.a_img_360x360);
    const authorDescription = useSelector((state: IRPStore) => state.article.authorDetail.author?.description);
    const location = useLocation();
    const articlesPage = parseSearch(location.search)?.page;

    return (
        <Row as="section" css={props.className}>
            <Col sm={4} md={5} lg={5} css={flexAbsoluteCenter}>
                {!!authorImageUrl ? (
                    <Image ratio={{xs: "1/1"}} css={authorImage} src={authorImageUrl} alt={authorName ?? ""} width="360px" height="360px" />
                ) : (
                    <AuthorBoxImgPlaceholder />
                )}
            </Col>
            <Col sm={4} md={7} lg={11}>
                <div css={authorInfoOrder}>
                    <Text css={[mb(2), order(1)]} variant="headline_1">
                        {authorName} {articlesPage && ` - strona ${articlesPage}`}
                    </Text>
                    <AuthorSocialIcons css={[order(4), pl(1), mb(4), onDesktop(order(2), mb(0))]} />
                    <AuthorCategories css={[order(3), authorColHolder]} />
                </div>

                <Text variant="body_copy_2" css={[mb(3), display("block"), textAlign("center"), onDesktop(mb(0), textAlign("left"))]}>
                    <span dangerouslySetInnerHTML={{__html: authorDescription?.replace(/\n/g, "<br />") ?? ""}} />
                </Text>
            </Col>
        </Row>
    );
};

const AuthorCategories = (props: {className?: string}) => {
    const authorCategories = useSelector((state: IRPStore) => state.article.authorDetail.author?.stats?.categories);
    const theme = useTheme();
    const brandColor = theme.colors.primary;
    const lightColor = theme.colors.gray[700];

    return (
        <>
            {!!authorCategories && (
                <div css={props.className}>
                    {authorCategories.map((category) => (
                        <div key={category} css={categoryItem}>
                            <CheckIcon fill={lightColor} size="1.6" wrapperSize="1.6" wrapperColor={brandColor} />
                            <Text css={ml(1)} color={lightColor} variant="body_copy_2">
                                {category}
                            </Text>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

const AuthorSocialIcons = (props: {className?: string}) => {
    const facebook = useSelector((state: IRPStore) => state.article.authorDetail.author?.facebook);
    const twitter = useSelector((state: IRPStore) => state.article.authorDetail.author?.twitter);
    const email = useSelector((state: IRPStore) => state.article.authorDetail.author?.email);
    const linkedin = useSelector((state: IRPStore) => state.article.authorDetail.author?.linkedin);
    const website = useSelector((state: IRPStore) => state.article.authorDetail.author?.website);

    const social = [
        ...(facebook ? [{alt: "facebook", url: facebook, icon: FacebookIcon}] : []),
        ...(twitter ? [{alt: "twitter", url: twitter, icon: TwitterIcon}] : []),
        ...(linkedin ? [{alt: "linkedin", url: linkedin, icon: LinkedinIcon}] : []),
        ...(website ? [{alt: "website", url: website, icon: WebsiteIcon}] : []),
        ...(email ? [{alt: "email", url: `mailto:${email}`, icon: EmailIcon, target: "_blank"}] : [])
    ];

    return (
        <>
            <div css={props.className}>
                {social.map(({icon: Icon, alt, url, target}) => {
                    return (
                        <a key={alt} href={url as string} rel="nofollow noopener" css={[pointer, mr(3), display("inline-block")]} target={target}>
                            <Icon size="2.5" key={alt} />
                        </a>
                    );
                })}
            </div>
        </>
    );
};

const authorImage = [
    mh("auto"),
    mb(4),
    display("block"),
    css`
        border-radius: 50%;
        width: 27.2rem;
        height: 27.2rem;
    `,
    onDesktop(css`
        width: 36rem;
        height: 36rem;
        ${mh(0)}
        ${mb(0)}
    `)
];

const authorInfoOrder = css`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${onDesktop(css`
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
    `)};
`;

const authorColHolder = css`
    ${flexAlignCenter};
    ${mb(3)};
    flex-wrap: wrap;
    justify-content: center;
    ${onDesktop(css`
        justify-content: flex-start;
    `)}
`;

const categoryItem = css`
    ${flexAlignCenter};
    ${mr(2)};
    white-space: nowrap;
`;
